import {
  MuiIconMap,
  muiPiggyBank,
  muiCar,
  muiCard,
  muiHouseOutline,
  muiShareScreen,
  muiChevronLeft,
  muiLightbulb,
  muiChartLine,
} from '@ally/metronome-icons'

const ADOBE_ICON_MAP = {
  'bank-pig': muiPiggyBank,
  'car-front': muiCar,
  'credit-card': muiCard,
  'home-outline': muiHouseOutline,
  laptop: muiShareScreen,
  'larrow-solid': muiChevronLeft,
  lightbulb: muiLightbulb,
  'line-chart': muiChartLine,
}

export type AdobeIconKeys = keyof typeof ADOBE_ICON_MAP

export const getAdobeIcon = (iconName: AdobeIconKeys): MuiIconMap =>
  ADOBE_ICON_MAP[iconName] || muiLightbulb
